import React from 'react';
import {
  Upload,
  Download,
  FileText,
  X
} from 'lucide-react';

const AttachmentsSection = ({
  log,
  attachments,
  uploadProgress,
  onFileUpload,
  onDownloadAttachment,
  onRemoveAttachment
}) => {
  if (!log) return null;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        <Upload size={16} className="inline mr-1" />
        Attachments
      </label>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
        <input
          type="file"
          id="file-upload"
          multiple
          onChange={onFileUpload}
          className="hidden"
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        />
        <label
          htmlFor="file-upload"
          className="cursor-pointer flex flex-col items-center"
        >
          <Upload size={32} className="text-gray-400 mb-2" />
          <span className="text-sm text-gray-600">
            Click to upload files or drag and drop
          </span>
          <span className="text-xs text-gray-500 mt-1">
            PDF, Images, Documents (Max 10MB each)
          </span>
        </label>
      </div>

      {/* Upload Progress */}
      {Object.keys(uploadProgress).length > 0 && (
        <div className="mt-4 space-y-2">
          {Object.entries(uploadProgress).map(([fileId, progress]) => (
            <div key={fileId} className="flex items-center space-x-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div
                  className="h-2 rounded-full bg-cyan-600 transition-all"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <span className="text-sm text-gray-600">{progress}%</span>
            </div>
          ))}
        </div>
      )}

      {/* Attached Files */}
      {attachments.length > 0 && (
        <div className="mt-4 space-y-2">
          <h4 className="text-sm font-medium text-gray-700">Attached Files:</h4>
          {attachments.map((attachment) => {
            return (
              <div key={attachment.id} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-2">
                  <FileText size={16} className="text-gray-400 flex-shrink-0" />
                  <span className="text-sm text-gray-700 truncate" title={attachment.filename}>{attachment.filename}</span>
                  <span className="text-xs text-gray-500 flex-shrink-0">
                    ({(attachment.size / (1024 * 1024)).toFixed(2)} MB)
                  </span>
                  {attachment.temporary && (
                    <span className="text-xs text-orange-600 bg-orange-100 px-1 rounded flex-shrink-0">
                      Pending upload
                    </span>
                  )}
                </div>
                <div className="flex items-center space-x-2 flex-shrink-0">
                  {!attachment.temporary && attachment.service_log_id && (
                    <button
                      type="button"
                      onClick={() => onDownloadAttachment(attachment)}
                      className="text-cyan-600 hover:text-cyan-800 transition-colors"
                      title="Download file"
                    >
                      <Download size={16} />
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => onRemoveAttachment(attachment.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                    title="Remove file"
                  >
                    <X size={16} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AttachmentsSection;
